import jQuery from 'jquery';

jQuery(function ($) {
    'use strict';

    const $dropdownContainers = $('.filter-form__dropdown');

    $dropdownContainers.each(function () {
        let $container = $(this);
        $container.find('.filter-form__dropdown__opener').click(function (e) {
            e.preventDefault();
            const expanded = $(this).attr('aria-expanded');
            if (expanded === 'true') {
                $container.removeClass('open');
                $(this).attr('aria-expanded', 'false');
            } else {
                $dropdownContainers.removeClass('open').find('.filter-form__dropdown__opener').attr('aria-expanded', 'false');
                $container.addClass('open');
                $(this).attr('aria-expanded', 'true');
            }
        });
    });

    $('.filter-form__field:not(.filter-form__query)').find('input, select').on('change', function() {
        $(this).closest('form').submit();
    });

    $('.filter-form__tags__opener').on('click', function (e) {
        e.preventDefault();
        const expanded = $(this).attr('aria-expanded');
        if (expanded === 'true') {
            $(this).closest('.filter-form__lower').removeClass('show-tags');
            $(this).attr('aria-expanded', 'false');
        } else {
            $(this).closest('.filter-form__lower').addClass('show-tags');
            $(this).attr('aria-expanded', 'true');
        }
    });

    $('.filter-form .tag-list input').on('change', function () {
        console.log($(this));
        $(this).closest('form').submit();
    });
});
